import type { ReactNode } from 'react';
import { when, type WhenParameters } from '../../utils/when';

/**
 * Switch component. Must be exhaustive or receive fallback.
 * @param expression Expression to evaluate.
 * @param cases Record that maps each possible value of 'expression' to content.
 * @param fallback Default content.
 */
export const When = <E extends string | number, CE extends E>(
    props: WhenParameters<E, CE, ReactNode, ReactNode>
) => {
    return when(props);
};
